import { motion } from 'framer-motion'
import Header from '../components/Header'

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4, delay },
})

interface Post {
  title: string
  desc: string
  tag: string
  href: string
  platform: 'LinkedIn' | 'Site' | 'GitHub'
  date: string
  pinned?: boolean
}

const posts: Post[] = [
  {
    title: 'O código que executa em todo request sem aparecer na lista de plugins',
    desc: 'wp-content/mu-plugins/ roda antes de qualquer hook, sem opção de desativar pela UI. Local favorito de backdoor persistente. O post cobre o que bloquear (PHP em uploads, XML-RPC, enumeração de usuários) e por que o hardening precisa viver ali dentro.',
    tag: 'Cyber',
    href: 'https://pt.linkedin.com/posts/matheus-edson-linhares-4620b82b1_cybersecurity-wordpress-devsecops-activity-7463687652203048961-pZwS',
    platform: 'LinkedIn',
    date: '22 mai 2026',
    pinned: true,
  },
  {
    title: 'CPL subindo, orçamento crescendo, criativo novo toda semana. O problema era outro',
    desc: '50% de bounce. PageSpeed mobile: 47. 6 segundos entre o clique e a página carregar. O dinheiro não queimava no leilão do Google ou Meta, queimava no carregamento. 9 sites WordPress, 4 fases de otimização, 2 semanas: pior LP foi de 47,8 → 89 mobile (+41,2pts). Mesma verba, mesmo criativo, CPL caindo.',
    tag: 'Engineering',
    href: 'https://pt.linkedin.com/posts/matheus-edson-linhares-4620b82b1_gtmengineering-buildinpublic-wordpress-activity-7462962878178938880-2sdi',
    platform: 'LinkedIn',
    date: '20 mai 2026',
  },
  {
    title: 'Seu site está invisível pro ChatGPT, Perplexity e Claude',
    desc: 'Não é bug, é configuração que quase ninguém fez ainda no BR. robots.txt com Content-Signal, llms.txt com contexto de negócio em markdown, H2 como perguntas naturais que IA indexa como resposta. Aplicado em 280 LPs: buscas de IA passaram a citar o conteúdo diretamente.',
    tag: 'GEO',
    href: 'https://pt.linkedin.com/posts/matheus-edson-linhares-4620b82b1_seu-site-est%C3%A1-invis%C3%ADvel-pro-chatgpt-perplexity-activity-7462147709538455552-f5p4',
    platform: 'LinkedIn',
    date: '18 mai 2026',
  },
  {
    title: 'A maioria das empresas implementa IA e dá o mesmo prompt pra todo mundo',
    desc: 'Estratégia segmentada pra rodar Claude na empresa: skills por papel, MCPs com permissões individuais e logs de interação pra revisão semanal. Tráfego Meta vê API. Análise de dados vê BigQuery. Criativo não vê credencial nenhuma.',
    tag: 'IA',
    href: 'https://www.linkedin.com/posts/matheus-edson-linhares-4620b82b1_a-maioria-das-empresas-implementa-ia-e-d%C3%A1-activity-7460705607462031360-wOLY',
    platform: 'LinkedIn',
    date: '14 mai 2026',
  },
  {
    title: 'Fui promovido a Growth Engineer, mas percebi algo',
    desc: 'Aconteceu em janeiro. Só fui contar agora. Promoção atrasada como prova: um webhook falhou numa sexta, calculei a perda, construí o sistema em 48h. 4.200 leads recuperados, R$200k+ que iam embora.',
    tag: 'Pivot',
    href: 'https://www.linkedin.com/posts/matheus-edson-linhares-4620b82b1_growthengineer-gtm-automacao-activity-7459550393778286592-jX6c',
    platform: 'LinkedIn',
    date: '11 mai 2026',
  },
  {
    title: 'Fiz esse motion 100% com IA em 5 minutos',
    desc: 'Tem imperfeição? Tem. Mas a direção e a velocidade de evolução é o que importa. Encontro da Ads Performers em Uberlândia com Gabi Vitorino sobre IA aplicada a marketing, dados e criativo.',
    tag: 'IA',
    href: 'https://www.linkedin.com/posts/matheus-edson-linhares-4620b82b1_esse-motion-foi-feito-100-por-ia-quer-saber-activity-7442966265096216577-FC4z',
    platform: 'LinkedIn',
    date: 'abr 2026',
  },
  {
    title: 'Customer Success com n8n: 10k clientes virando parceiros',
    desc: 'Como construímos um Pipeline de Valor: monitora performance, identifica quem está abaixo do esperado e inscreve automaticamente em um Growth Track com guias de mercado, monetização e cases. Tech não substitui relacionamento. Escala empatia.',
    tag: 'Customer Success',
    href: 'https://www.linkedin.com/posts/matheus-edson-linhares-4620b82b1_customersuccess-n8n-retention-activity-7420114921146740736-oEFj',
    platform: 'LinkedIn',
    date: 'fev 2026',
  },
  {
    title: 'Sistema de captura fallback com redundância tripla',
    desc: '3 camadas: interceptação client-side com keepalive, API dedicada com Raw SQL, orquestração de resiliência via n8n + cron workers. Zero perda de dados crítica em 30 dias rodando em escala. Stack: PHP + MySQL + JavaScript.',
    tag: 'Engineering',
    href: 'https://www.linkedin.com/posts/matheus-edson-linhares-4620b82b1_fullstack-systemdesign-resilienceengineering-activity-7419018722662776832-Kkg6',
    platform: 'LinkedIn',
    date: 'fev 2026',
  },
  {
    title: 'Qual a diferença entre um dev e um arquiteto de soluções?',
    desc: 'Visita à sede da Langflow em Uberlândia com o GIAA. Low-code não é limitação: é IDE simplificada e agnóstica. O desafio muda de "como construir?" para "como conectar melhor as peças?". Energia vai pra lógica e valor entregue, não código pesado.',
    tag: 'Arquitetura',
    href: 'https://www.linkedin.com/posts/matheus-edson-linhares-4620b82b1_lowcode-nocode-langflow-activity-7367213199965827072-ZeNt',
    platform: 'LinkedIn',
    date: 'out 2025',
  },
  {
    title: 'Comecei como Dev Web & Automação numa fintech',
    desc: 'Entrada como Junior em uma das maiores fintechs do Brasil. Processos inteligentes e automação transformando negócio. Início da jornada que virou Growth Engineer 18 meses depois.',
    tag: 'Carreira',
    href: 'https://www.linkedin.com/posts/matheus-edson-linhares-4620b82b1_portugu%C3%AAs-tenho-o-prazer-de-compartilhar-activity-7364281882366148610-Sbgu',
    platform: 'LinkedIn',
    date: 'set 2025',
  },
  {
    title: 'DevTools para growth: 21 lugares no browser que todo marketeiro deveria conhecer',
    desc: 'Console, Network, Application, Performance, Sources. Cada aba revela algo que impacta diretamente campanhas e rastreamento. Cada esconderijo te dá um código pra colar em /stats, quem zera ganha sessão estratégica.',
    tag: 'Tutorial',
    href: 'https://matheusedson.com/stats',
    platform: 'Site',
    date: 'ao vivo',
  },
]

const tagColors: Record<string, string> = {
  'Pivot':             'rgba(251,191,36,0.15)',
  'Engineering':       'rgba(96,165,250,0.15)',
  'Arquitetura':       'rgba(168,85,247,0.15)',
  'IA':                'rgba(167,139,250,0.15)',
  'Customer Success':  'rgba(244,114,182,0.15)',
  'Carreira':          'rgba(34,197,94,0.15)',
  'Tutorial':          'rgba(74,222,128,0.15)',
  'GEO':               'rgba(79,126,247,0.15)',
  'Cyber':             'rgba(248,113,113,0.15)',
}

const tagBorder: Record<string, string> = {
  'Pivot':             'rgba(251,191,36,0.35)',
  'Engineering':       'rgba(96,165,250,0.35)',
  'Arquitetura':       'rgba(168,85,247,0.35)',
  'IA':                'rgba(167,139,250,0.35)',
  'Customer Success':  'rgba(244,114,182,0.35)',
  'Carreira':          'rgba(34,197,94,0.35)',
  'Tutorial':          'rgba(74,222,128,0.35)',
  'GEO':               'rgba(79,126,247,0.35)',
  'Cyber':             'rgba(248,113,113,0.35)',
}

export default function Blog() {
  const featured = posts.find(p => p.pinned)
  const rest = posts.filter(p => !p.pinned)

  return (
    <>
      <Header />
      <main style={{ maxWidth: 820, margin: '0 auto', padding: '3rem 1.5rem 6rem' }}>

        <motion.div {...fade(0)} style={{ marginBottom: '3rem' }}>
          <p style={{ fontSize: '0.75rem', color: 'var(--muted)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1rem' }}>
            Blog e publicações
          </p>
          <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: '0.75rem' }}>
            O que estou construindo
          </h1>
          <p style={{ color: 'var(--muted)', fontSize: '0.95rem', lineHeight: 1.65, maxWidth: 560 }}>
            Casos reais de engenharia de growth: incidentes, arquitetura, números. Publicados no LinkedIn e indexados aqui.
          </p>
        </motion.div>

        {/* Featured */}
        {featured && (
          <motion.a
            {...fade(0.05)}
            href={featured.href}
            target="_blank" rel="noopener noreferrer"
            style={{
              display: 'block',
              padding: '1.75rem',
              background: 'linear-gradient(135deg, rgba(167,139,250,0.06), rgba(167,139,250,0.01))',
              border: '1px solid rgba(167,139,250,0.3)',
              borderRadius: 12,
              marginBottom: '2rem',
              textDecoration: 'none', color: 'inherit',
              transition: 'border-color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(167,139,250,0.55)'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(167,139,250,0.3)'}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.8rem', flexWrap: 'wrap' }}>
              <span style={{ fontSize: '0.62rem', color: '#a78bfa', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 700 }}>★ Mais recente</span>
              <span style={{
                fontSize: '0.65rem', padding: '0.15rem 0.5rem', borderRadius: 4,
                background: tagColors[featured.tag] ?? 'var(--bg3)',
                color: 'var(--muted)', border: `1px solid ${tagBorder[featured.tag] ?? 'var(--border)'}`,
              }}>{featured.tag}</span>
              <span style={{ fontSize: '0.7rem', color: 'var(--muted2)' }}>{featured.platform}</span>
              <span style={{ fontSize: '0.7rem', color: 'var(--muted2)', marginLeft: 'auto' }}>{featured.date}</span>
            </div>
            <p style={{ fontWeight: 700, fontSize: '1.2rem', marginBottom: '0.6rem', lineHeight: 1.3, letterSpacing: '-0.02em' }}>{featured.title}</p>
            <p style={{ color: 'var(--muted)', fontSize: '0.88rem', lineHeight: 1.65 }}>{featured.desc}</p>
          </motion.a>
        )}

        {/* Lista */}
        <motion.div {...fade(0.1)} style={{ display: 'flex', flexDirection: 'column', gap: '1px', background: 'var(--border)', border: '1px solid var(--border)', borderRadius: 10, overflow: 'hidden' }}>
          {rest.map((post, i) => (
            <a
              key={i}
              href={post.href}
              target="_blank" rel="noopener noreferrer"
              style={{ display: 'block', background: 'var(--bg2)', padding: '1.25rem 1.5rem', textDecoration: 'none', color: 'inherit', transition: 'background 0.15s' }}
              onMouseEnter={e => (e.currentTarget.style.background = 'var(--bg3)')}
              onMouseLeave={e => (e.currentTarget.style.background = 'var(--bg2)')}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.6rem', flexWrap: 'wrap' }}>
                <span style={{
                  fontSize: '0.65rem', padding: '0.15rem 0.5rem', borderRadius: 4,
                  background: tagColors[post.tag] ?? 'var(--bg3)',
                  color: 'var(--muted)', border: `1px solid ${tagBorder[post.tag] ?? 'var(--border)'}`,
                }}>{post.tag}</span>
                <span style={{ fontSize: '0.7rem', color: 'var(--muted2)' }}>{post.platform}</span>
                <span style={{ fontSize: '0.7rem', color: 'var(--muted2)', marginLeft: 'auto' }}>{post.date}</span>
              </div>
              <p style={{ fontWeight: 600, fontSize: '0.95rem', marginBottom: '0.4rem', lineHeight: 1.4 }}>{post.title}</p>
              <p style={{ color: 'var(--muted)', fontSize: '0.82rem', lineHeight: 1.6 }}>{post.desc}</p>
            </a>
          ))}
        </motion.div>

        {/* LinkedIn CTA */}
        <motion.div {...fade(0.18)} style={{ marginTop: '2.5rem', padding: '1.5rem', border: '1px solid var(--border)', borderRadius: 10, background: 'var(--bg2)', display: 'grid', gridTemplateColumns: '1fr auto', gap: '1rem', alignItems: 'center' }}>
          <div>
            <p style={{ fontSize: '0.92rem', fontWeight: 600, marginBottom: '0.3rem' }}>3 posts por semana, sem furos.</p>
            <p style={{ fontSize: '0.78rem', color: 'var(--muted)', lineHeight: 1.5 }}>
              Cases reais de growth engineering em PT-BR. Incidentes, arquitetura, números concretos.
            </p>
          </div>
          <a
            href="https://www.linkedin.com/in/matheus-edson-linhares-4620b82b1/"
            target="_blank" rel="noopener noreferrer"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
              padding: '0.65rem 1.2rem', background: 'var(--text)', color: '#080808',
              borderRadius: 7, fontWeight: 600, fontSize: '0.85rem', textDecoration: 'none',
              whiteSpace: 'nowrap',
            }}
          >Seguir no LinkedIn</a>
        </motion.div>

      </main>
    </>
  )
}
